import { RSAA } from 'redux-api-middleware';

import {
  CreateParticipantFormDataProps,
  EditParticipantFormDataProps,
} from '../../components/clipGeneratorV2/participants/participant.types';
import { toFormData } from '../../helpers/requestHelper';

const BASE_ROUTE = `/after-effects/participants`;

const GET_AFTER_EFFECTS_PARTICIPANT_REQUEST = 'GET_PARTICIPANT_REQUEST';
const GET_AFTER_EFFECTS_PARTICIPANT_SUCCESS = 'GET_PARTICIPANT_SUCCESS';
const GET_AFTER_EFFECTS_PARTICIPANT_FAILURE = 'GET_PARTICIPANT_FAILURE';

export const getAfterEffectsParticipants = () => ({
  [RSAA]: {
    types: [
      GET_AFTER_EFFECTS_PARTICIPANT_REQUEST,
      GET_AFTER_EFFECTS_PARTICIPANT_SUCCESS,
      GET_AFTER_EFFECTS_PARTICIPANT_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'GET',
  },
});

const POST_AFTER_EFFECTS_PARTICIPANT_REQUEST = 'POST_PARTICIPANT_REQUEST';
const POST_AFTER_EFFECTS_PARTICIPANT_SUCCESS = 'POST_PARTICIPANT_SUCCESS';
const POST_AFTER_EFFECTS_PARTICIPANT_FAILURE = 'POST_PARTICIPANT_FAILURE';

export const createAfterEffectsParticipant = (body: CreateParticipantFormDataProps) => ({
  [RSAA]: {
    types: [
      POST_AFTER_EFFECTS_PARTICIPANT_REQUEST,
      POST_AFTER_EFFECTS_PARTICIPANT_SUCCESS,
      POST_AFTER_EFFECTS_PARTICIPANT_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

const DELETE_AFTER_EFFECTS_PARTICIPANT_REQUEST = 'DELETE_PARTICIPANT_REQUEST';
const DELETE_AFTER_EFFECTS_PARTICIPANT_SUCCESS = 'DELETE_PARTICIPANT_SUCCESS';
const DELETE_AFTER_EFFECTS_PARTICIPANT_FAILURE = 'DELETE_PARTICIPANT_FAILURE';

export const deleteAfterEffectsParticipant = (participantId: string) => ({
  [RSAA]: {
    types: [
      DELETE_AFTER_EFFECTS_PARTICIPANT_REQUEST,
      DELETE_AFTER_EFFECTS_PARTICIPANT_SUCCESS,
      DELETE_AFTER_EFFECTS_PARTICIPANT_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${participantId}`,
    method: 'DELETE',
  },
});

const EDIT_AFTER_EFFECTS_PARTICIPANT_REQUEST = 'EDIT_PARTICIPANT_REQUEST';
const EDIT_AFTER_EFFECTS_PARTICIPANT_SUCCESS = 'EDIT_PARTICIPANT_SUCCESS';
const EDIT_AFTER_EFFECTS_PARTICIPANT_FAILURE = 'EDIT_PARTICIPANT_FAILURE';

export const editAfterEffectsParticipant = (participantId: string, body: EditParticipantFormDataProps) => ({
  [RSAA]: {
    types: [
      EDIT_AFTER_EFFECTS_PARTICIPANT_REQUEST,
      EDIT_AFTER_EFFECTS_PARTICIPANT_SUCCESS,
      EDIT_AFTER_EFFECTS_PARTICIPANT_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${participantId}`,
    method: 'PATCH',
    body: toFormData(body),
  },
});
